import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import InternalError from '../components/InternalError';
import ErrorActions from '../actions/ErrorActions';

const propTypes = {
  showErrorPage: PropTypes.bool,
  appVersion: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  errorId: PropTypes.string,
  dispatch: PropTypes.func
};

/** @extends React.Component */
export class InternalErrorContainer extends BcReactComponent {
  // eslint-disable-next-line babel/camelcase
  unstable_handleError() {
    this.props.dispatch(ErrorActions.showErrorPage());
  }

  render() {
    const { appVersion, children, showErrorPage, errorId } = this.props;
    if (showErrorPage) {
      return <InternalError appVersion={appVersion} errorId={errorId} />;
    }

    return children;
  }
}

const mapStateToProps = state => ({
  showErrorPage: state.getIn(['errors', 'internalError', 'showErrorPage']),
  errorId: state.getIn(['errors', 'internalError', 'error', 'id']),
  appVersion: state.getIn(['app', 'appVersion'])
});

InternalErrorContainer.propTypes = propTypes;

export default connect(mapStateToProps)(InternalErrorContainer);
